import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChatService } from '../../../service/chat.service';
import { ChatMessage } from '../../../model/chat-message';
import { takeUntil } from 'rxjs/operators';
import { Receiver } from '../../../model/receiver';
import { ReceiverType } from '../../../model/receiver-type';
import { getRandomDarkColor } from 'src/app/shared/util/converter-util';
import { toVisibleDateTimeFormat } from 'src/app/shared/util/date-util';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ChannelService } from '../../../service/channel.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.scss']
})
export class ChatMessagesComponent implements OnDestroy, AfterViewInit, OnInit {

  @ViewChild('messageWindow') messageWindow: ElementRef;

  chatMessages: ChatMessage[] = [];

  width: number;

  unsubscribe$: Subject<void> = new Subject();
  receivers: Receiver[] = [];

  private activeChannel: string = ReceiverType.ALL;

  private colorsMap: Map<string, string> = new Map();

  constructor(private chatService: ChatService, private cd: ChangeDetectorRef,
    private translate: TranslateService, private channelService: ChannelService, private elRef: ElementRef) { }

  ngOnInit(): void {
    this.observeDialogResize();
  }

  ngAfterViewInit(): void {
    this.channelService.receiversObservable$.pipe(takeUntil(this.unsubscribe$)).subscribe(receivers => {
      this.reset();
      this.receivers = receivers;
      this.subscribeChannel();
    });

    this.channelService.getDataObservable().pipe(takeUntil(this.unsubscribe$)).subscribe(messages => {
      messages.forEach(message => {
        if (message.readed === false && message.username !== this.chatService.getUsername()) {
          message.readed = true;
          this.chatService.markReaded(message);
        }
      });
      this.chatMessages = messages;
      this.cd.detectChanges();
      this.scrollToBottom();
    });
    this.scrollToBottom();
  }

  ngOnDestroy(): void {
    this.reset();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  send(message: ChatMessage): void {
    this.chatService.add(Object.assign(message, {
      receivers: this.receivers,
      date: new Date(),
      channel: this.activeChannel
    }));
  }

  getColor(username: string): string {
    if (this.colorsMap.has(username)) {
      return this.colorsMap.get(username);
    }
    else {
      const color = getRandomDarkColor();
      this.colorsMap.set(username, color);
      return color;
    }
  }

  toHrDate(date: Date): string {
    return toVisibleDateTimeFormat(moment(date));
  }

  getChatNames(): string {
    if (this.activeChannel == ReceiverType.ALL)
      return this.translate.instant('allChat');
    return this.translate.instant('userChats') + this.receivers.map(receiver => receiver.name).join(', ');
  }

  observeDialogResize(): void {
    const parentElement = this.elRef.nativeElement.parentElement;
    const observe = new ResizeObserver(entries => {
      const selectorElement = parentElement.firstChild;
      const selectorWidth = selectorElement.offsetWidth;
      const windowWidth = entries[0].contentRect.width;
      this.width = windowWidth - selectorWidth;
      this.cd.detectChanges();
    });
    observe.observe(parentElement);
  }


  private scrollToBottom(): void {
    const element = (this.messageWindow.nativeElement as HTMLElement);;
    element.scrollTop = element.scrollHeight;
  }

  private subscribeChannel(): void {
    if (this.receivers.length > 0)
      this.chatService.join(this.getChannel(), this.receivers);
  }

  private getChannel(): string {
    if (this.receivers.length === 0)
      return '';
    if (this.receivers.length == 1 && this.receivers[0].receiverType === ReceiverType.VEHICLE)
      return this.activeChannel = this.receivers[0].name;
    if (this.receivers.length == 1 && this.receivers[0].receiverType === ReceiverType.ALL)
      return this.activeChannel = ReceiverType.ALL;
    return this.activeChannel = this.receivers.map(rcv => rcv.name).sort().join(',');
  }

  private reset(): void {
    this.channelService.unstoreData();
    this.chatMessages = [];
    this.activeChannel = '';
  }
}

